import Vue from 'vue'
import VueRouter, { RouteConfig, RawLocation } from 'vue-router'

import { RouterModule } from '@/store/modules/router'
import { UserModule } from '@/store/modules/user'
import { getRouters2, getFunctionsByMenuName } from '@/api/common'
import { eventBus, EventType } from '@/utils/eventBus'

// 权限缓存对象，用于存储已获取的权限
const permissionCache: Record<string, any[]> = {};


// 路由列表 ----------  一级路由2
import Marketing from '@/views/marketing/index/index.vue' // 市场运营
import Message from '@/views/message/index/index.vue' // CRM消息
const ProjectList = () => import('@/views/project-list/index/index.vue') // 项目列表
const AuthorityManagement = () => import('@/views/authority-management/index/index.vue') // 权限管理
const Draffts = () => import('@/views/drafts/index.vue') // 草稿箱
const Customer = () => import('@/views/customer/index/index.vue') // 客户
const CnvenienceTools = () => import('@/views/convenience-tools/index/index.vue')  // 便利工具
const FinancialCenter = () => import('@/views/financial-center/index/index.vue')  // 财务中心
const ReviewSetting = () => import('@/views/review-setting/index/index.vue')  // 审批设置-
const Resale = () => import('@/views/resale/index/index.vue')  // 转销
const ClassManagement = () => import('@/views/ClassManagement/index/index.vue')  // 班级管理
const None = () => import('@/views/none.vue')  // 404


// 市场运营 ---------- 二级路由
const MarketClues = () => import('@/views/marketing/market-clues/index/index.vue')  // 市场线索
const MarketCluesStatisticsData = () => import('@/views/marketing/market-clues/statistics-data/index.vue')  // 市场线索 ------ 数据统计
const MarketNewClue = () => import('@/views/marketing/market-clues/new-clue/index.vue')  // 市场线索 ------ 新建线索
const MarketSeeClue = () => import('@/views/marketing/market-clues/see-clue/index.vue')  // 市场线索 ------ 查看线索
const maketClueCusmoterInfo = () => import('@/views/marketing/market-clues/cusmoter-info/index.vue')  // 市场线索 ------ 查看客户
const marketFollow = () => import('@/views/marketing/market-clues/marketFollow/index.vue')  // 市场线索 ------ 查看客户
const marketFollowUp = () => import('@/views/marketing/market-clues/follow/index.vue')  // 市场线索 ------ 回访
const marketFollowRecord = () => import('@/views/marketing/market-clues/follow-record/index.vue')  // 市场线索 ------ 回访记录
const marketFollowStatic = () => import('@/views/marketing/market-clues/follow-record-static/index.vue')  // 市场线索 ------ 回访记录统计报表

const CooperationManagement = () => import('@/views/marketing/Cooperation-management/index/index.vue') // 合作伙伴
const CooperationStatisticsData = () => import('@/views/marketing/Cooperation-management/statistics-data/index.vue') // 合作伙伴 - 数据统计
const chanelGiveStudentRate = () => import('@/views/marketing/Cooperation-management/chanelGiveStudentRate/index.vue') // 合作伙伴 - 渠道送生同比统计数据
const GiveStudent = () => import('@/views/marketing/Cooperation-management/give-student/index.vue') // 合作伙伴 - 送生明细
const NewVisit = () => import('@/views/marketing/Cooperation-management/new-visit/index.vue') // 合作伙伴 - 拜访
const VisitRecord = () => import('@/views/marketing/Cooperation-management/visit-record/index.vue') // 合作伙伴 - 拜访记录
const newPartner = () => import('@/views/marketing/Cooperation-management/new-partner/index.vue') // 合作伙伴 - 新建合作方
const seePartner = () => import('@/views/marketing/Cooperation-management/see-partner/index.vue') // 合作伙伴 - 查看合作方
const Consult = () => import('@/views/marketing/Cooperation-management/consult/index.vue'); // 合作伙伴 - 咨询
const ConsultRecord = () => import("@/views/marketing/Cooperation-management/consultRecord/index.vue"); // 合作伙伴 - 查看咨询记录
const VisitStatisticsTable = () => import('@/views/marketing/Cooperation-management/visitStatisticsTabel/index.vue') // 合作伙伴统计报表

const ChannelDelivery = () => import("@/views/marketing/channel-delivery/index/index.vue") // 渠道投放
const NewChannel = () => import('@/views/marketing/channel-delivery/new-channel/index.vue') // 渠道投放 - 新建渠道
const SeeChannel = () => import('@/views/marketing/channel-delivery/see-channel/index.vue') // 渠道投放 - 查看渠道
const ChannelStatisticsData = () => import('@/views/marketing/channel-delivery/statistics-data/index.vue')

// 客户 ------ 二级路由
const transfromCustomer = () => import('@/views/customer/customer-transfrom/index/index.vue') // 转化客户
const transfromCustomerStatisticsData = () => import('@/views/customer/customer-transfrom/statistics-data/index.vue') // 转化客户 ----- 数据统计
const transfromCustomerInfo = () => import('@/views/customer/customer-transfrom/transfrom-customer-info/index.vue') // 转化客户  ------  转化客户详情
const transfromCustomerEdit = () => import('@/views/customer/customer-transfrom/edit-customer-info/index.vue') // 转化客户 ------ 编辑客户信息
const transfromCustomerFollow = () => import('@/views/customer/customer-transfrom/follow/index.vue') // 转化客户 ----- 跟进
const transfromCustomerFollowRecord = () => import('@/views/customer/customer-transfrom/follow-record/index.vue') // 转化客户 ---- 跟进记录
const transformCustomerCollectionReport = () => import('@/views/customer/customer-transfrom/collection-report/index.vue') // 转化客户 统计报表

const bClassifyCustomer = () => import('@/views/customer/b-classify-customer/index/index.vue') // B端客户
const bClassifyCustomerFollow = () => import('@/views/customer/b-classify-customer/follow/index.vue') // B端客户 ----- 跟进
const addBClassifyCustomer = () => import('@/views/customer/b-classify-customer/add-bClassify-customer/index.vue') // 新增客户
const statisticsBClassifyCustomer = () => import('@/views/customer/b-classify-customer/statistics-bClassify-customer/index.vue') // B端客户统计表格

const pubCustomer = () => import('@/views/customer/highSeas/index/index.vue') // 公海
const pubCustomerInfo = () => import('@/views/customer/highSeas/pubCustomerInfo/index.vue') // 公海详情
const pubCustomerStatic = () => import('@/views/customer/highSeas/statistics-data/index.vue') // 公海统计


// 项目列表 ------ 二级路由
const allProject = () => import('@/views/project-list/all-project/index/index.vue') //  总项目
const allProjectInfo = () => import('@/views/project-list/all-project/all-project-info/index.vue') // 总项目详情、编辑、新建
const allProjectStudent = () => import('@/views/project-list/all-project/all-project-student/index.vue') // 总项目--报名学员
const allProjectStatisticalData = () => import('@/views/project-list/all-project/statistical-data/index.vue') // 总项目统计数据
const allProjectStudentFollowRecord = () => import('@/views/project-list/all-project/follow-record/index.vue') // 报名学员 ---- 跟进记录

const cooperationProject = () => import('@/views/project-list/cooperative-partner-project/index/index.vue') // 合作伙伴项目列表
const shelfPanterProject = () => import('@/views/project-list/cooperative-partner-project/shelf-panter-project/index.vue') //  上架合作伙伴项目
const partnerProjectInfo = () => import('@/views/project-list/cooperative-partner-project/partner-project-info/index.vue') //  合作伙伴项目列表详情

const dissertationProject = () => import('@/views/project-list/dissertation-project/index/index.vue')  //论文项目
const dissertationProjectInfo = () => import('@/views/project-list/dissertation-project/dissertation-project-info/index.vue') //论文列表查看详情
const dissertationProjectEdit = () => import('@/views/project-list/dissertation-project/dissertation-project-edit/index.vue') //论文列表新增编辑

// 转销 ------ 二级路由
const resaleCustomer = () => import('@/views/resale/resaleCustomer/index/index.vue')  //  转销客户
const resaleCustomerInfo = () => import('@/views/resale/resaleCustomer/resaleCustomerInfo/index.vue')  //  转销客户
const resaleOrder = () => import('@/views/resale/resaleOrder/index/index.vue')  //  转销订单
const ResaleInvoiceRecord = () => import('@/views/resale/resaleOrder/invoiceRecord/invoiceRecord.vue')  //  转销订单--开票记录


// 财务中心 ------- 二级路由
const order = () => import('@/views/financial-center/order/index/index.vue')  // 财务中心 ----- 订单
const orderRecord = () => import('@/views/financial-center/order/record/index.vue')  // 订单 ----- 订单转退记录
const newOrdinaryOrder = () => import('@/views/financial-center/order/new-ordinary-order/index.vue')  // 订单 ----- 新建普通订单
const orderInfo = () => import('@/views/financial-center/order/order-info/index.vue')
const newPaperOrder = () => import('@/views/financial-center/order/new_paper_order/index.vue') // 订单 ----- 新建论文订单
const paperOrderInfo = () => import('@/views/financial-center/order/paper_order_info/index.vue')  // 订单 ----- 查看/编辑论文订单
const statisticsData = () => import('@/views/financial-center/order/statistics-data/index.vue')  // 订单 ----- 统计图表
const ARSummaryReport = () => import('@/views/financial-center/order/ARSummaryReport/index.vue')  // 订单-应收款账统计报表
const ARChannelDetailReport = () => import('@/views/financial-center/order/ARChannelDetailReport/index.vue')  // 订单-应收账款渠道明细统计报表

const backMoney = () => import('@/views/financial-center/back-money/index/index.vue') // 回款
const newBackMoneyStudent = () => import('@/views/financial-center/back-money/new-back-money-student/index.vue') // 新建学生回款
const newBackMoneyMechanism = () => import('@/views/financial-center/back-money/new-back-money-mechanism/index.vue') // 新建机构回款
const backMoneyStudentInfo = () => import('@/views/financial-center/back-money/back-money-student-info/index.vue') // 学生回款详情
const backMoneyParnterInfo = () => import('@/views/financial-center/back-money/back-money-parnter-info/index.vue') // 合作伙伴回款
const collectionReport = () => import('@/views/financial-center/back-money/collection-report/index.vue') // 回款 ----- 统计图表



// 财务中心返佣
const commission = () => import('@/views/financial-center/commission/index/index.vue')  // 财务中心 ----- 返佣
const commissionInfo = () => import('@/views/financial-center/commission/commission-info/index.vue')  // 返佣 ----- 查看/编辑
const commissionAdd = () => import('@/views/financial-center/commission/commission-add/index.vue')  // 返佣 ----- 新增
const commissionEdit = () => import('@/views/financial-center/commission/commission-edit/index.vue')  // 返佣 ----- 编辑
const commissionMoneyInfo = () => import('@/views/financial-center/commission/commission-money-info/index.vue')  // 返佣 ----- 编辑
const rebateStatistics = () => import('@/views/financial-center/commission/rebate-statistics/index.vue')  // 财务中心 ----- 返佣 ----- 统计图表

// 财务中心开票
const invoice = () => import('@/views/financial-center/makeInvoice/index/index.vue')  // 财务中心 ----- 开票
// import invoice = () => import('@/views/financial-center/archiveList/index/index.vue'
const makeInvoiceInfo = () => import('@/views/financial-center/makeInvoice/makeInvoice-info/index.vue')  // 开票 ----- 查看/编辑
const makeInvoiceAdd = () => import('@/views/financial-center/makeInvoice/makeInvoice-add/index.vue')  // 开票 ----- 新增

// 财务中心归档
const archive = () => import('@/views/financial-center/archiveList/index/index.vue')  // 财务中心 ----- 归档列表
/*归档- 销售排名报表*/
const salesRankingReport = () => import('@/views/financial-center/archiveList/SalesRankingReport/index.vue')

// 财务中心归档统计报表
const archiveStatistical = () => import('@/views/financial-center/statisticalReport/index.vue') // 财务中心 ----- 归档统计报表


// 财务中心市场费用
const marketCost = () => import('@/views/financial-center/marketCost/index/index.vue') // 财务中心 ----- 市场费用
const marketCostAdd = () => import('@/views/financial-center/marketCost/marketCost-add/index.vue') // 财务中心 ----- 新建市场费用
const marketCostInfo = () => import('@/views/financial-center/marketCost/marketCostInfo/index.vue') // 财务中心 ----- 编辑市场费用/详情
const statisticsReport = () => import('@/views/financial-center/marketCost/statistics-report/index.vue') // 财务中心 ----- 市场费用 ----- 统计图表

// 财务中心-撞单
const repeatOrder = () => import('@/views/financial-center/repeatOrder/index/index.vue') // 财务中心 ---- 撞单列表
const repeatOrderAdd = () => import('@/views/financial-center/repeatOrder/repeatOrder_add/index.vue') // 财务中心 ---- 新建撞单
const repeatOrderInfo = () => import("@/views/financial-center/repeatOrder/repeatOrder_info/index.vue"); // 财务中心 ---- 编辑撞单
const repeatOrderStatic = () => import("@/views/financial-center/repeatOrder/repeatOrderStatic/index.vue") // 财务中心 ---- 撞单- 统计报表
const contract = () => import("@/views/financial-center/contract/index/index.vue") // 财务中心 ---- 合同- 合同报表
const contractAdd = () => import("@/views/financial-center/contract/contract-add/index.vue") // 财务中心 ---- 合同- 新建合同
const contractAddAgent = () => import("@/views/financial-center/contract/contract-add-agent/index.vue") // 财务中心 ---- 合同- 新建合同
const contractStudentInfo = () => import("@/views/financial-center/contract/contractStudentInfo/index.vue") // 财务中心 ---- 合同- 新建合同
const contractInfo = () => import("@/views/financial-center/contract/contractInfo/index.vue") // 财务中心 ---- 合同- 合同详情
// /*渠道投放*/
// import adServing from "@/views/marketing/adServing/index/adServing" // 市场 ---- 投放- 投放列表
// import adServingAdd from "@/views/marketing/adServing/adServing_add/adServing_add" // 市场 ---- 投放- 新建投放
// import adServingInfo from "@/views/marketing/adServing/adServingInfo/adServingInfo" // 市场 ---- 投放- 投放详情
// import channel from "@/views/marketing/channel/index/channel" // 市场 ---- 渠道- 渠道列表
// import channelAdd from "@/views/marketing/channel/channel_add/channel_add" // 市场 ---- 渠道- 新建渠道
// import channelInfo from "@/views/marketing/channel/channel_Info/channel_Info" // 市场 ---- 渠道- 渠道详情



// 财务中心 ------- 退款
const refund = () => import('@/views/financial-center/refund/index/index.vue')
const newRefund = () => import('@/views/financial-center/refund/new-refund/index.vue')
const refundInfo = () => import('@/views/financial-center/refund/refund-info/index.vue')
const refundReport = () => import('@/views/financial-center/refund/refund-report/index.vue') // 退款 ----- 统计图表

//财务中心 合同模板
const contractTemplate = () => import('@/views/financial-center/contract-template/index/index.vue') // 合同模板
const newContractTemplate = () => import('@/views/financial-center/contract-template/newContractTemplate/index.vue') // 新建/编辑合同模板
const contractTemplateInfo = () => import('@/views/financial-center/contract-template/contractTemplateInfo/index.vue') // 合同模板详情

// 权限管理 ------------ 二级路由
const NoSetting = () => import('@/views/authority-management/no-setting/index.vue') // 未配置人员
const RoleManagement = () => import('@/views/authority-management/role-management/index.vue') // 角色管理
const AuthoritySetting = () => import('@/views/authority-management/authority-setting/index.vue') // 权限设置
const DataShare = () => import('@/views/authority-management/data-share/index.vue') // 数据共享、转

// 审批配置 ------------ 二级路由
const ReviewSettinges = () => import('@/views/review-setting/review-settinges/index.vue') // 审批流列表展示
const NewReview = () => import('@/views/review-setting/new-review/index.vue') // 新建审批流


// CRM消息 ------------ 二级路由 审批
const MessageRemind = () => import('@/views/message/remind/Index/index.vue') // 提醒
const MessageNotice = () => import('@/views/message/notice/index.vue') // 通知

const MessageApproval = () => import('@/views/message/approval/index/index.vue') // 审批
const pageBackClue = () => import('@/views/message/approval/back-clue/index.vue') // 我的审批 ---- 回退线索
const transfromCustomerCancleBackClue = () => import('@/views/message/approval/cancle-back-clue/index.vue') // 我的提交 ---- 撤销回退线索
const reviewOrder = () => import('@/views/message/approval/order/index.vue') // 订单
const paperOrder = () => import('@/views/message/approval/paperOrder/index.vue') // 论文订单
const approvalBackMoneu = () => import('@/views/message/approval/back-money/index.vue') //
const commissionInfos = () => import('@/views/message/approval/commission-info/index.vue')  //返佣
const makeInvoice = () => import('@/views/message/approval/makeInvoice/index.vue')  //开票
const cooperativePartner = () => import('@/views/message/approval/cooperative-partner/index.vue') // 合作伙伴
const marketCostMsg = () => import('@/views/message/approval/marketCost/index.vue')  //市场费用
const repeatOrderMsg = () => import('@/views/message/approval/repeatOrder/index.vue')  //撞单
const contractMsg = () => import('@/views/message/approval/contract/index.vue')  //合同
const followRecord = () => import('@/views/message/approval/ApprovalFollowRecord/index.vue')  //转化客户跟进记录
const resaleInvoiceRecord = () => import('@/views/message/approval/resaleInvoice/index.vue')  //转销开票审批详情


// crm消息 跳转详情
const newMsgOrder = () => import('@/views/message/remind/order/index.vue') // 订单详情
const backMoneyMsg = () => import('@/views/message/remind/back-money/index.vue') // 回款详情
const makeInvoiceMsg = () => import('@/views/message/remind/makeInvoice/index.vue') // 开票详情
const commissionInfoMsg = () => import('@/views/message/remind/commission-info/index.vue') // 返佣详情
const cooperativePartnerMsg = () => import('@/views/message/remind/cooperative-partner/index.vue') // 合作伙伴详情
const marketCostMSg = () => import('@/views/message/remind/marketCost/index.vue') // 市场费用详情
const repeatOrderRemindMSg = () => import('@/views/message/remind/repeatOrder/index.vue') // 撞单详情
const refundMSg = () => import('@/views/message/remind/refund/index.vue') // 退款详情
// import pageBackClueMSg from '@/views/message/remind/back-clue/index.vue' // 转化客户详情
const cancleBackClueMSg = () => import('@/views/message/remind/cancle-back-clue/index.vue') // 转化客户详情
const marketCluwMsg = () => import('@/views/message/remind/see-clue/index.vue') // 线索详情
const contractMsgRemindMSg = () => import('@/views/message/remind/contract/index.vue') // 合同详情
const CustomerBusinessFollowRemindMSg = () => import('@/views/message/remind/bClassifyCustomer-info/index.vue') // 合同详情
const remindFollowRecord = () => import('@/views/message/remind/remindfollowRecord/index.vue') // 转化客户跟进记录
const pubCustomerApproval = () => import('@/views/message/approval/pubCustomerInfo/index.vue') // 转化客户调入公海 --- 审批
const pubCustomerRemind = () => import('@/views/message/remind/pubCustomerInfo/index.vue') // 转化客户调入公海 --- 提醒
const resaleApproval = () => import('@/views/message/approval/resale/index.vue') // 转销回款 --- 审批
const resaleRemind = () => import('@/views/message/remind/resale/index.vue') // 转销回款 --- 提醒
const allProjectRemind = () => import('@/views/message/remind/all-project/index.vue') // 总项目提醒详情
const classRemind = () => import('@/views/message/remind/classInfo/index.vue') // 班级提醒详情
const resaleInvoiceRemind = () => import('@/views/message/remind/resaleInvoice/index.vue') // 转销开票提醒详情

// 便利工具
const schoolList = () => import('@/views/convenience-tools/school-list/index/index.vue') // 学校列表
const studentList = () => import('@/views/convenience-tools/student-list/index/index.vue') // 学校列表
const studentDetail = () => import('@/views/convenience-tools/school-list/detail/index.vue') // 学校详情
const bulkImport = () => import('@/views/convenience-tools/bulk_import/index/index.vue') // 批量导入


/*
*  班级管理
* 2024-4-23 add */
const ClassManagementStudent = () => import('@/views/ClassManagement/student/index/index.vue') // 学生列表
const ClassesStudentInfo = () => import('@/views/ClassManagement/student/studentInfo/index.vue') // 学生详情
const ClassStudentStaticData = () => import('@/views/ClassManagement/student/staticData/index.vue') // 统计数据

const ClassMange = () => import('@/views/ClassManagement/class/index/index.vue') // 班级列表
const AddClass = () => import('@/views/ClassManagement/class/addClass/index.vue') // 新增班级
const ClassInfo = () => import('@/views/ClassManagement/class/classInfo/index.vue') // 班级详情
const ClassStudent = () => import('@/views/ClassManagement/class/class-student/index.vue') // 报名学员
const ClassStaticData = () => import('@/views/ClassManagement/class/staticData/index.vue') //班级-统计表
const AddClassStudentProduce = () => import('@/views/ClassManagement/class/addProduce/index.vue') // 班级-报名学员- 产出新建
const ClassStudentProduceInfo = () => import('@/views/ClassManagement/class/produceInfo/index.vue') // 班级-报名学员- 产出记录-查看
const ClassStudentProduceRecord = () => import('@/views/ClassManagement/class/produceRecord/index.vue') // 班级-报名学员- 产出记录
const ClassStudentWarningRecord = () => import('@/views/ClassManagement/class/warningRecord/index.vue') //  班级-报名学员- 预警记录
// 产出模板
const ProduceMouldList = () => import('@/views/ClassManagement/produceMould/index/index.vue')//模版列表
const ProduceMouldAdd = () => import('@/views/ClassManagement/produceMould/addProduceMould/index.vue')//模版新建
const ProduceMouldInfo = () => import('@/views/ClassManagement/produceMould/produceMouldInfo/index.vue')//模版详情

// 登录页
const Login = () => import('@/views/login/index.vue') // 学校详情

// 网申
// import customerInfo from '@/views/applyOfStudent/index.vue' // 查询学生信息

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
VueRouter.prototype.push = function push(location: RawLocation) {
  return (originalPush.call(this, location) as any).catch((err: any) => err)
}

const routes: Array<RouteConfig> = [
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    redirect: '/message/remind'
  },

  {
    path: '/applicationForm',
    name: 'applicationForm',
    component: () => import('@/h5/applicationForm.vue'), //B端客户
  },
  {
    path: '/applicationForms',
    name: 'applicationForms',
    component: () => import('@/h5/applicationForms.vue'), //市场线索
    meta: {
      title: '集思未来',
    }
  },
  {
    path: '/applicationFormsEn',
    name: 'applicationFormsEn',
    component: () => import('@/h5/applicationFormsEn.vue'), //B端客户英文二维码
    meta: {
      title: '集思未来',
    }
  },
  {
    path: '/applicationFormsEnNew',
    name: 'applicationFormsEnNew',
    component: () => import('@/h5/applicationFormsEnNew.vue'),  //上海新河湾
    meta: {
      title: '集思未来',
    }
  },
  {
    path: '/applicationFormEn',
    name: 'applicationFormEn',
    component: () => import('@/h5/applicationFormEn.vue'), //B端客户英文二维码
    meta: {
      title: '集思未来',
    }
  },
  {
    path: '/qbhtgjzxFrom',
    name: 'qbhtgjzxFrom',
    component: () => import('@/h5/applicationFormsEn2023_4_17.vue'), //上海七宝德怀特高级中学 报名表
  },
  {
    path: '/signUp',
    name: 'signUp',
    component: () => import('@/h5/signUp.vue'), //
    meta: {
      title: '报名入口',
    }
  },
  {
    path: '/publicityRegistration',
    name: 'publicityRegistration',
    component: () => import('@/h5/publicityRegistration.vue'), //
    meta: {
      title: '宣讲报名',
    }
  },
  {
    path: '/RegistrationForLectures',
    name: 'RegistrationForLectures',
    component: () => import('@/h5/RegistrationForLectures.vue'), //B端客户
    meta: {
      title: '讲座报名',
    }
  },
  {
    path: '/EducationExhibitionRegistration',
    name: 'EducationExhibitionRegistration',
    component: () => import('@/h5/EducationExhibitionRegistration.vue'), //B端客户
    meta: {
      title: '集思未来',
    }
  },
  {
    path: '/channelApplyFrom',
    name: 'channelApplyFrom',
    component: () => import('@/h5/channelApply.vue'), //渠道报名表
    meta: {
      title: '集思未来',
    }
  },
  {
    path: '/signPay',
    name: 'signPay',
    component: () => import('@/h5/signPay.vue'), // 签署支付
    meta: {
      title: '合同支付',
    }
  },
  {
    path: '/signPayReturn',
    name: 'signPayReturn',
    component: () => import('@/h5/signPayReturn.vue'), // 签署支付
    meta: {
      title: '支付详情',
    }
  },
  {
    path: '/login',
    name: 'login', component: Login
  },
  {
    path: '/customerInfo',
    name: 'customerInfo',
    component: () => import('@/views/applyOfStudent/index.vue') //网申 查询学生信息
  },
  // CRM消息
  {
    path: '/message', name: 'Message', component: Message, meta: { title: 'CRM消息' },
    children: [
      { path: 'remind', name: 'MessageRemind', component: MessageRemind, meta: { title: '提醒' } },
      { path: 'notice', name: 'MessageNotice', component: MessageNotice, meta: { title: '通知' } },
      { path: 'approval', name: 'MessageApproval', component: MessageApproval, meta: { title: '审批' } },
      { path: 'pageBackClue', name: 'pageBackClue', component: pageBackClue, meta: { title: '回退线索审批' } },
      { path: 'transfromCustomerCancleBackClue', name: 'transfromCustomerCancleBackClue', component: transfromCustomerCancleBackClue, meta: { title: '撤回退回线索' } },
      { path: 'reviewOrder', name: 'reviewOrder', component: reviewOrder, meta: { title: '订单详情' } },
      { path: 'paperOrder', name: 'paperOrder', component: paperOrder, meta: { title: '论文订单详情' } },
      { path: 'approvalBackMoneu', name: 'approvalBackMoneu', component: approvalBackMoneu, meta: { title: '回款详情' } },
      { path: 'commissionInfos', name: 'commissionInfos', component: commissionInfos, meta: { title: '返佣详情' } },
      { path: 'makeInvoice', name: 'makeInvoice', component: makeInvoice, meta: { title: '开票详情' } },
      { path: 'refund', name: 'refund', component: () => import('@/views/message/approval/refund/index.vue'), meta: { title: '退款详情' } },
      { path: 'cooperativePartner', name: 'cooperativePartner', component: cooperativePartner, meta: { title: '合作伙伴详情' } },
      { path: 'marketCost', name: 'marketCost', component: marketCostMsg, meta: { title: '市场费用详情' } },
      { path: 'repeatOrder', name: 'repeatOrder', component: repeatOrderMsg, meta: { title: '撞单详情' } },
      { path: 'contract', name: 'contract', component: contractMsg, meta: { title: '合同详情' } },
      { path: 'newMsgOrder', name: 'newMsgOrder', component: newMsgOrder, meta: { title: '订单详情' } },
      { path: 'backMoneyMsg', name: 'backMoneyMsg', component: backMoneyMsg, meta: { title: '回款详情' } },
      { path: 'makeInvoiceMsg', name: 'makeInvoiceMsg', component: makeInvoiceMsg, meta: { title: '开票详情' } },
      { path: 'commissionInfoMsg', name: 'commissionInfoMsg', component: commissionInfoMsg, meta: { title: '返佣详情' } },
      { path: 'cooperativePartnerMsg', name: 'cooperativePartnerMsg', component: cooperativePartnerMsg, meta: { title: '合作伙伴详情' } },
      { path: 'marketCostMSg', name: 'marketCostMSg', component: marketCostMSg, meta: { title: '市场费用详情' } },
      { path: 'repeatOrderRemindMSg', name: 'repeatOrderRemindMSg', component: repeatOrderRemindMSg, meta: { title: '撞单详情' } },
      { path: 'refundMSg', name: 'refundMSg', component: refundMSg, meta: { title: '退款详情' } },
      // { path: 'pageBackClueMSg', name: 'pageBackClueMSg', component: pageBackClueMSg, meta: { title: '退回线索详情' } },
      { path: 'cancleBackClueMSg', name: 'cancleBackClueMSg', component: cancleBackClueMSg, meta: { title: '撤回退回线索详情' } },
      { path: 'marketCluwMsg', name: 'marketCluwMsg', component: marketCluwMsg, meta: { title: '线索详情' } },
      { path: 'contractMsg', name: 'ContractMsg', component: contractMsgRemindMSg, meta: { title: '合同详情' } },
      { path: 'CustomerBusinessFollowRemind', name: 'CustomerBusinessFollowRemind', component: CustomerBusinessFollowRemindMSg, meta: { title: 'B端客户详情' } },
      { path: 'followRecord', name: 'followRecord', component: followRecord, meta: { title: '转化客户跟进详情' } },
      { path: 'remindFollowRecord', name: 'remindFollowRecord', component: remindFollowRecord, meta: { title: '转化客户跟进详情' } },
      { path: 'pubCustomerApproval', name: 'pubCustomerApproval', component: pubCustomerApproval, meta: { title: '转化客户调入公海' } },// 审批
      { path: 'pubCustomerRemind', name: 'pubCustomerRemind', component: pubCustomerRemind, meta: { title: '转化客户调入公海' } }, // 提醒
      { path: 'resaleApproval', name: 'resaleApproval', component: resaleApproval, meta: { title: '转销回款' } }, // 审批
      { path: 'resaleRemind', name: 'resaleRemind', component: resaleRemind, meta: { title: '转销回款' } }, // 提醒
      { path: 'allProjectRemind', name: 'allProjectRemind', component: allProjectRemind, meta: { title: '总项目详情' } }, // 提醒
      { path: 'classRemind', name: 'classRemind', component: classRemind, meta: { title: '班级详情' } }, // 提醒
      { path: 'resaleInvoiceRemind', name: 'resaleInvoiceRemind', component: resaleInvoiceRemind, meta: { title: '转销开票详情' } }, // 提醒
      { path: 'resaleInvoiceRecord', name: 'resaleInvoiceRecord', component: resaleInvoiceRecord, meta: { title: '转销开票详情' } }, // 审批
    ]
  },

  // 市场线索
  {
    path: '/marketing', name: 'Marketing', component: Marketing, meta: { title: '市场运营' },
    children: [
      { path: 'marketClues', name: 'MarketClues', component: MarketClues, meta: { title: '市场线索' } },
      { path: 'marketNewClue', name: 'MarketNewClue', component: MarketNewClue, meta: { title: '新建线索' } },
      { path: 'marketCluesStatisticsData', name: 'MarketCluesStatisticsData', component: MarketCluesStatisticsData, meta: { title: '数据统计' } },
      { path: 'marketSeeClue', name: 'MarketSeeClue', component: MarketSeeClue, meta: { title: '查看线索' } },
      { path: 'maketClueCusmoterInfo', name: 'maketClueCusmoterInfo', component: maketClueCusmoterInfo, meta: { title: '查看客户详情' } },
      { path: 'marketFollow', name: 'marketFollow', component: marketFollow, meta: { title: '跟进统计报表' } },
      { path: 'marketFollowUp', name: 'marketFollowUp', component: marketFollowUp, meta: { title: '回访' } },
      { path: 'marketFollowRecord', name: 'marketFollowRecord', component: marketFollowRecord, meta: { title: '回访记录' } },
      { path: 'marketFollowStatic', name: 'marketFollowStatic', component: marketFollowStatic, meta: { title: '回访记录统计报表' } },


      { path: 'channelDelivery', name: 'CooperationManagement', component: ChannelDelivery, meta: { title: '渠道投放' } },
      { path: 'newChannel', name: 'NewChannel', component: NewChannel, meta: { title: '新建渠道' } },
      { path: 'seeChannel', name: 'SeeChannel', component: SeeChannel, meta: { title: '查看渠道' } },
      { path: 'channelStatisticsData', name: 'ChannelStatisticsData', component: ChannelStatisticsData, meta: { title: '数据统计' } },
      { path: 'CooperationStatisticsData', name: 'CooperationStatisticsData', component: CooperationStatisticsData, meta: { title: '数据统计' } },
      { path: 'chanelGiveStudentRate', name: 'chanelGiveStudentRate', component: chanelGiveStudentRate, meta: { title: '渠道送生同比' } },

      { path: 'cooperationManagement', name: 'ChannelDelivery', component: CooperationManagement, meta: { title: '合作伙伴' } },
      { path: 'GiveStudent', name: 'GiveStudent', component: GiveStudent, meta: { title: '送生明细' } },
      { path: 'NewVisit', name: 'NewVisit', component: NewVisit, meta: { title: '合作伙伴拜访' } },
      { path: 'VisitRecord', name: 'VisitRecord', component: VisitRecord, meta: { title: '拜访记录' } },
      { path: 'newPartner', name: 'newPartner', component: newPartner, meta: { title: '新建合作方' } },
      { path: 'seePartner', name: 'seePartner', component: seePartner, meta: { title: '查看合作方' } },
      { path: 'Consult', name: 'Consult', component: Consult, meta: { title: '合作伙伴咨询' } },
      { path: 'ConsultRecord', name: 'ConsultRecord', component: ConsultRecord, meta: { title: '查看咨询记录' } },
      {
        path: 'VisitStatisticsTable',
        name: 'VisitStatisticsTable',
        component: VisitStatisticsTable,
        meta: { title: '拜访统计报表' }
      },

      /*
 * 投放*/
      // { path: 'adServing', name: 'adServing', component: adServing, meta: { title: '投放' } },
      // { path: 'adServingAdd', name: 'adServingAdd', component: adServingAdd, meta: { title: '新建投放' } },
      // { path: 'AdServingInfo', name: 'AdServingInfo', component: adServingInfo, meta: { title: '投放详情' } },
      // /*渠道*/
      // { path: 'channel', name: 'channel', component: channel, meta: { title: '渠道' } },
      // { path: 'channelAdd', name: 'channelAdd', component: channelAdd, meta: { title: '新建渠道' } },
      // { path: 'channelInfo', name: 'channelInfo', component: channelInfo, meta: { title: '渠道详情' } },
    ]
  },


  { path: '/drafts', name: 'Darffts', component: Draffts, meta: { title: '草稿箱' } },
  {
    path: '/projectList', name: 'ProjectList', component: ProjectList, meta: { title: '项目列表' },
    children: [
      { path: 'allProject', name: 'AllProject', component: allProject, meta: { title: '总项目' } },
      { path: 'allProjectInfo', name: 'allProjectInfo', component: allProjectInfo, meta: { title: '总项目详情' } },
      { path: 'allProjectStudent', name: 'allProjectStudent', component: allProjectStudent, meta: { title: '报名学员' } },
      { path: 'allProjectStudentFollowRecord', name: 'allProjectStudentFollowRecord', component: allProjectStudentFollowRecord, meta: { title: '跟进记录' } },

      { path: 'allProjectStatisticalData', name: 'allProjectStatisticalData', component: allProjectStatisticalData, meta: { title: '项目统计数据' } },

      { path: 'cooperationProject', name: 'cooperationProject', component: cooperationProject, meta: { title: '合作伙伴项目' } },
      { path: 'shelfPanterProject', name: 'shelfPanterProject', component: shelfPanterProject, meta: { title: '上架合作伙伴项目' } },
      { path: 'partnerProjectInfo', name: 'partnerProjectInfo', component: partnerProjectInfo, meta: { title: '项目上架情况' } },

      { path: 'dissertationProject', name: 'dissertationProject', component: dissertationProject, meta: { title: '论文项目' } },
      { path: 'dissertationProjectInfo', name: 'dissertationProjectInfo', component: dissertationProjectInfo, meta: { title: '论文项目详情' } },
      { path: 'dissertationProjectEdit', name: 'dissertationProjectEdit', component: dissertationProjectEdit, meta: { title: '论文项目编辑' } },
    ]
  },
  {
    path: '/authorityManagement', name: 'AuthorityManagement', component: AuthorityManagement, meta: { title: '权限管理' },
    children: [
      { path: 'noSetting', name: 'NoSetting', component: NoSetting, meta: { title: '未配置人员' } },
      { path: 'roleManagement', name: 'RoleManagement', component: RoleManagement, meta: { title: '角色管理' } },
      { path: 'authoritySetting', name: 'AuthoritySetting', component: AuthoritySetting, meta: { title: '权限设置' } },
      { path: 'dataShare', name: 'NoSeDataSharetting', component: DataShare, meta: { title: '数据共享/转移' } },
    ]
  },
  // 客户
  {
    path: '/customer', name: 'Customer', component: Customer, meta: { title: '客户' },
    children: [
      { path: 'transfromCustomer', name: 'TransfromCustomer', component: transfromCustomer, meta: { title: '转化客户' } },
      { path: 'transfromCustomerInfo', name: 'transfromCustomerInfo', component: transfromCustomerInfo, meta: { title: '转化客户详情' } },
      { path: 'transfromCustomerStatisticsData', name: 'transfromCustomerStatisticsData', component: transfromCustomerStatisticsData, meta: { title: '数据统计' } },
      { path: 'transfromCustomerEdit', name: 'transfromCustomerEdit', component: transfromCustomerEdit, meta: { title: '修改客户信息' } },
      { path: 'transfromCustomerFollow', name: 'transfromCustomerFollow', component: transfromCustomerFollow, meta: { title: '跟进' } },
      { path: 'transfromCustomerFollowRecord', name: 'transfromCustomerFollowRecord', component: transfromCustomerFollowRecord, meta: { title: '跟进记录' } },
      { path: 'transformCustomerCollectionReport', name: 'transformCustomerCollectionReport', component: transformCustomerCollectionReport, meta: { title: '统计报表' } },
      { path: 'bClassifyCustomer', name: 'bClassifyCustomer', component: bClassifyCustomer, meta: { title: 'B端客户' } },
      { path: 'bClassifyCustomerFollow', name: 'bClassifyCustomerFollow', component: bClassifyCustomerFollow, meta: { title: 'B端客户跟进' } },
      { path: 'addBClassifyCustomer', name: 'addBClassifyCustomer', component: addBClassifyCustomer, meta: { title: '操作客户信息' } },
      { path: 'statisticsBClassifyCustomer', name: 'statisticsBClassifyCustomer', component: statisticsBClassifyCustomer, meta: { title: 'B端客户统计数据' } },
      { path: 'pubCustomer', name: 'pubCustomer', component: pubCustomer, meta: { title: '公海' } },
      { path: 'pubCustomerInfo', name: 'pubCustomerInfo', component: pubCustomerInfo, meta: { title: '公海客户详情' } },
      { path: 'pubCustomerStatic', name: 'pubCustomerStatic', component: pubCustomerStatic, meta: { title: '公海客户详情' } },
    ]
  },


  {
    path: '/convenienceTools', name: 'CnvenienceTools', component: CnvenienceTools, meta: { title: '便利工具' },
    children: [
      { path: 'school', name: 'schoolList', component: schoolList, meta: { title: '学校列表' } },
      { path: 'studentDetail', name: 'studentDetail', component: studentDetail, meta: { title: '已报名学员' } },

      { path: 'import', name: 'bulkImport', component: bulkImport, meta: { title: '批量导入' } },
      { path: 'customerLibrary', name: 'studentList', component: studentList, meta: { title: '学生库' } },

    ]
  },
  {
    path: '/financialCenter', name: 'FinancialCenter', component: FinancialCenter, meta: { title: '财务中心' },
    children: [
      { path: 'order', name: 'order', component: order, meta: { title: '订单' } },
      { path: 'orderRecord', name: 'orderRecord', component: orderRecord, meta: { title: '转退记录' } },
      { path: 'newOrdinaryOrder', name: 'newOrdinaryOrder', component: newOrdinaryOrder, meta: { title: '新建订单' } },
      { path: 'orderInfo', name: 'orderInfo', component: orderInfo, meta: { title: '订单详情' } },
      { path: 'newPaperOrder', name: 'newPaperOrder', component: newPaperOrder, meta: { title: '新建论文订单' } },
      { path: 'paperOrderInfo', name: 'paperOrderInfo', component: paperOrderInfo, meta: { title: '论文订单详情' } },
      { path: 'statisticsData', name: 'statisticsData', component: statisticsData, meta: { title: '统计图表' } },
      { path: 'ARSummaryReport', name: 'ARSummaryReport', component: ARSummaryReport, meta: { title: '应收账款统计报表' } },
      { path: 'ARChannelDetailReport', name: 'ARChannelDetailReport', component: ARChannelDetailReport, meta: { title: '应收账款渠道明细统计报表' } },

      { path: 'commission', name: 'commission', component: commission, meta: { title: '返佣' } },
      { path: 'commissionInfo', name: 'commissionInfo', component: commissionInfo, meta: { title: '返佣详情' } },
      { path: 'commissionAdd', name: 'commissionAdd', component: commissionAdd, meta: { title: '新建返佣' } },
      { path: 'commissionEdit', name: 'commissionEdit', component: commissionEdit, meta: { title: '编辑返佣' } },
      { path: 'commissionMoneyInfo', name: 'commissionMoneyInfo', component: commissionMoneyInfo, meta: { title: '返佣打款信息' } },



      { path: 'backMoney', name: 'backMoney', component: backMoney, meta: { title: '回款' } },
      { path: 'newBackMoneyStudent', name: 'newBackMoneyStudent', component: newBackMoneyStudent, meta: { title: '新建学生回款' } },
      { path: 'newBackMoneyMechanism', name: 'newBackMoneyMechanism', component: newBackMoneyMechanism, meta: { title: '新建合作伙伴回款' } },
      { path: 'backMoneyStudentInfo', name: 'backMoneyStudentInfo', component: backMoneyStudentInfo, meta: { title: '学生回款详情' } },
      { path: 'backMoneyParnterInfo', name: 'backMoneyParnterInfo', component: backMoneyParnterInfo, meta: { title: '合作伙伴回款详情' } },
      { path: 'collectionReport', name: 'collectionReport', component: collectionReport, meta: { title: '统计图表' } },



      { path: 'invoice', name: 'invoice', component: invoice, meta: { title: '开票' } },
      { path: 'makeInvoiceInfo', name: 'makeInvoiceInfo', component: makeInvoiceInfo, meta: { title: '开票详情' } },
      { path: 'makeInvoiceAdd', name: 'makeInvoiceAdd', component: makeInvoiceAdd, meta: { title: '新建开票' } },
      // { path: 'commissionEdit', name: 'commissionEdit', component: commissionEdit, meta: { title: '编辑返佣' } },
      { path: 'rebateStatistics', name: 'rebateStatistics', component: rebateStatistics, meta: { title: '返佣统计报表' } },

      { path: 'archive', name: 'archive', component: archive, meta: { title: '归档' } },
      { path: 'salesRankingReport', name: 'salesRankingReport', component: salesRankingReport, meta: { title: '归档销售排名报表' } },
      { path: 'archiveStatistical', name: 'archiveStatistical', component: archiveStatistical, meta: { title: '归档统计报表' } },

      { path: 'marketCost', name: 'MarketCost', component: marketCost, meta: { title: '市场费用' } },
      { path: 'marketCostAdd', name: 'marketCostAdd', component: marketCostAdd, meta: { title: '新建费用' } },
      { path: 'marketCostInfo', name: 'marketCostInfo', component: marketCostInfo, meta: { title: '费用详情' } },
      { path: 'statisticsReport', name: 'statisticsReport', component: statisticsReport, meta: { title: '费用统计报表' } },

      { path: 'refund', name: 'Refund', component: refund, meta: { title: '退款' } },
      { path: 'newRefund', name: 'newRefund', component: newRefund, meta: { title: '退款' } },
      { path: 'refundInfo', name: 'refundInfo', component: refundInfo, meta: { title: '退款' } },
      { path: 'refundReport', name: 'refundReport', component: refundReport, meta: { title: '统计图表' } },

      { path: 'repeatOrder', name: 'RepeatOrder', component: repeatOrder, meta: { title: '撞单' } },
      { path: 'repeatOrderAdd', name: 'repeatOrderAdd', component: repeatOrderAdd, meta: { title: '新建撞单' } },
      { path: 'repeatOrderInfo', name: 'repeatOrderInfo', component: repeatOrderInfo, meta: { title: '撞单详情' } },
      { path: 'repeatOrderStatic', name: 'repeatOrderStatic', component: repeatOrderStatic, meta: { title: '撞单统计报表' } },
      { path: 'contract', name: 'Contract', component: contract, meta: { title: '合同' } },
      { path: 'contractAdd', name: 'contractAdd', component: contractAdd, meta: { title: '新建合同' } },
      { path: 'contractAddAgent', name: 'contractAddAgent', component: contractAddAgent, meta: { title: '新建合同' } },
      { path: 'contractStudentInfo', name: 'contractStudentInfo', component: contractStudentInfo, meta: { title: '合同详情' } },
      { path: 'contractInfo', name: 'contractInfo', component: contractInfo, meta: { title: '合同详情' } },
      { path: 'contractTemplate', name: 'contractTemplate', component: contractTemplate, meta: { title: '合同模版' } },
      { path: 'newContractTemplate', name: 'newContractTemplate', component: newContractTemplate, meta: { title: '新建合同模板' } },
      { path: 'contractTemplateInfo', name: 'contractTemplateInfo', component: contractTemplateInfo, meta: { title: '合同模板详情' } },
    ]
  },
  {
    path: '/reviewSetting', name: 'ReviewSetting', component: ReviewSetting, meta: { title: '审批配置' },
    children: [
      { path: 'reviewSettings', name: 'ReviewSettinges', component: ReviewSettinges, meta: { title: '审批配置' } },
      { path: 'newReview', name: 'NewReview', component: NewReview, meta: { title: '新建审批流' } },
    ]
  },
  // 转销
  {
    path: '/resale', name: 'Resale', component: Resale, meta: { title: '转销' },
    children: [
      { path: 'customer', name: 'resaleCustomer', component: resaleCustomer, meta: { title: '转销客户' } },
      { path: 'resaleCustomerInfo', name: 'resaleCustomerInfo', component: resaleCustomerInfo, meta: { title: '转销客户详情' } },
      { path: 'orderList', name: 'resaleOrder', component: resaleOrder, meta: { title: '转销订单' } },
      { path: 'resaleInvoiceRecord', name: 'ResaleInvoiceRecord', component: ResaleInvoiceRecord, meta: { title: '转销开票' } },
    ]
  },
  // 班级管理
  {
    path: '/classManagement', name: 'ClassManagement', component: ClassManagement, meta: { title: '班级管理' },
    children: [
      { path: 'studentList', name: 'ClassManagementStudent', component: ClassManagementStudent, meta: { title: '学员列表' } },
      { path: 'classesStudentInfo', name: 'ClassesStudentInfo', component: ClassesStudentInfo, meta: { title: '学员详情' } },
      { path: 'ClassStudentStaticData', name: 'ClassStudentStaticData', component: ClassStudentStaticData, meta: { title: '学员详情' } },

      { path: 'classList', name: 'ClassMange', component: ClassMange, meta: { title: '班级列表' } },
      { path: 'addClass', name: 'AddClass', component: AddClass, meta: { title: '新增班级' } },
      { path: 'classInfo', name: 'ClassInfo', component: ClassInfo, meta: { title: '班级详情' } },
      { path: 'classStudent', name: 'ClassStudent', component: ClassStudent, meta: { title: '报名学员' } },
      { path: 'ClassStaticData', name: 'ClassStaticData', component: ClassStaticData, meta: { title: '统计表' } },
      { path: 'addClassStudentProduce', name: 'AddClassStudentProduce', component: AddClassStudentProduce, meta: { title: '新建产出' } },
      { path: 'ClassStudentProduceInfo', name: 'ClassStudentProduceInfo', component: ClassStudentProduceInfo, meta: { title: '产出详情' } },
      { path: 'ClassStudentProduceRecord', name: 'ClassStudentProduceRecord', component: ClassStudentProduceRecord, meta: { title: '产出记录' } },
      { path: 'ClassStudentWarningRecord', name: 'ClassStudentWarningRecord', component: ClassStudentWarningRecord, meta: { title: '预警记录' } },
      //产出模板
      { path: 'output', name: 'ProduceMouldList', component: ProduceMouldList, meta: { title: '产出模板' } },
      { path: 'produceMouldAdd', name: 'ProduceMouldAdd', component: ProduceMouldAdd, meta: { title: '新建模板' } },
      { path: 'produceMouldInfo', name: 'ProduceMouldInfo', component: ProduceMouldInfo, meta: { title: '模板详情' } },

    ]
  },
  { path: '*', name: '404', component: None },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})



const fun = async function (routerToID: number, toLevel2Path: string) {
  if (routerToID) {
    // 检查是否已经有二级菜单数据，如果有就不再调用接口
    if (!RouterModule.pathChildrens || RouterModule.pathChildrens.length === 0) {
      const data: any = await getRouters2({ id: routerToID })
      RouterModule.SET_PATHCHILDRENS(data.menuList)
    }
    
    const item = RouterModule.pathChildrens.filter(item => item.uri === toLevel2Path)[0]
    if (item) {
      // 每次都调用接口获取权限，不使用缓存
      const result: any = await getFunctionsByMenuName({ name: item.name })
      const permissions = result.functionsList || []
      UserModule.SET_BUTTONS(permissions)
      RouterModule.setRouter2(item)
      // 触发权限更新事件
      eventBus.$emit(EventType.PERMISSIONS_UPDATED, permissions)
    } else {
      const router2 = JSON.parse(window.sessionStorage.getItem('router2'))
      if (router2) {
        // 每次都调用接口获取权限，不使用缓存
        const result: any = await getFunctionsByMenuName({ name: router2.name })
        const permissions = result.functionsList || []
        UserModule.SET_BUTTONS(permissions)
        // 触发权限更新事件
        eventBus.$emit(EventType.PERMISSIONS_UPDATED, permissions)
      }
    }
  }
}

// 全局前置守卫，用来获取当前页面按钮，当前二级路由
router.beforeEach(async (to, from, next) => {
  to.meta.title && (to.meta.title == '报名入口' ||to.meta.title == '宣讲报名' || to.meta.title == '集思未来' || to.meta.title == '讲座报名' || to.meta.title == '合同支付' ) ? document.title = to.meta.title : document.title = '集思 CRM'

  const pathArr = ['/login','/applicationForm','/applicationForms','/applicationFormsEn','/applicationFormsEnNew','/applicationFormEn','/qbhtgjzxFrom','/signUp','/publicityRegistration']
  if (pathArr.includes(window.location.pathname) === false) {
    const toPath = to.matched[0].path
    const toLevel2Path = to.fullPath.split('/')[2]
    
    // 优化: 使用递归setTimeout替代setInterval，避免内存泄漏
    let attemptCount = 0
    const maxAttempts = 20 // 最大尝试次数，防止无限循环
    
    const checkRouterList = () => {
      attemptCount++
      
      // 超过最大尝试次数，停止检查
      if (attemptCount > maxAttempts) {
        console.warn('Router list not found after maximum attempts')
        return
      }
      
      const list = RouterModule.router1List
      if (list && list.length > 0) {
        const targetRoute = list.find(item => item.uri === toPath)
        if (targetRoute?.id) {
          fun(targetRoute.id, toLevel2Path)
          return // 找到后立即返回，停止递归
        }
      }
      
      // 未找到，继续尝试，使用setTimeout替代setInterval
      setTimeout(checkRouterList, 50)
    }
    
    // 开始检查
    checkRouterList()
  }
  next()
})

export default router
